import { animate, state, style, transition, trigger } from '@angular/animations';

const ANIMATION_TIMING = '10ms linear';
export const SUGGESTIONS_LIST_ANIMATIONS = [
  trigger('fadeInOut', [
    state('0', style({
      opacity: 0,
      visibility: 'hidden'
    })),
    state('1', style({
      opacity: 1,
      visibility: 'visible'
    })),
    transition('0 <=> 1', [
      animate(ANIMATION_TIMING)
    ])
  ]),
];
